import Resource from "./resource";

export class FeaturesConfigurationResource extends Resource {
    IsCommunityActionTemplatesEnabled: boolean;
    IsBuiltInRepoSyncEnabled: boolean;
    IsServiceMessageResourceCreationEnabled: boolean;
    IsBuiltInWorkerEnabled: boolean;
}

export default FeaturesConfigurationResource;